import React from 'react';
import { RenderInlineStyles } from './inline-styles';

export const Toolbar: React.FC<any> = ({ editorState, applyStyle }) => 
    <RenderInlineStyles editorState={editorState} applyStyle={applyStyle} />